import {Base} from "@/api/Base"

export class PlanCategoryList extends Base {
    path = "planCategory/list"
}